<template>
    <div>
        <!-- 顶栏 -->
        <el-row
            style="height: 64px"
            class="nav"
            type="flex"
            justify="space-between"
        >
            <div class="navcard">
                <div class="lbox" @click="gopage('communityServices1')">
                    <!-- <img src="@/assets/images/cloud/logo_Title-Mg.png" alt=""> -->
                    <!-- 绩溪市来苏社区智慧网格 -->
                </div>
                <div class="rbox" style="flex: 1">
                    <!-- <div @click="gopage('communityServices1')">
            <img src="../../assets/images/governmentAffairs/top_home.png" />
            <br />
            <span>首&nbsp;页</span>
          </div>
          <div :class="{ active: routeName == 'partyBuilding' }" @click="gopage('partyBuilding')">
              <img src="../../assets/images/governmentAffairs/top_dangqun.png" />
            <br />
            <span>智慧党建</span>
          </div>
          <div :class="{ active: routeName == 'zhengwu' }" @click="gopage('zhengwu')">
              <img src="../../assets/images/governmentAffairs/top_zhengce.png" />
            <br />
            <span>智慧政务</span>
          </div>
          <div :class="{ active: routeName == 'griddingindex' }" @click="gopage('griddingindex')">
            <img src="../../assets/images/governmentAffairs/top_wuye.png" />
            <br />
            <span>智慧治理</span>
          </div>
          <div :class="{ active: routeName == 'civilization' }" @click="gopage('civilization')">
              <img src="../../assets/images/governmentAffairs/top_xieshang.png" />
            <br />
            <span>文明创建</span>
          </div>
         <div :class="{ active: routeName == 'provideManage' }" @click="gopage('provideManage')">
           <img src="../../assets/images/governmentAffairs/top_yanglao.png" />
           <br />
           <span>智慧养老</span>
         </div>
          <div :class="{ active: routeName == 'partyReported' }" @click="gopage('theGridManagement')">
              <img src="../../assets/images/governmentAffairs/top_teshu.png" />
            <br />
            <span>智慧平安</span>
          </div>
          <div :class="{ active: routeName == 'zhzw' }" @click="gopage('dataCentreindex')">
              <img src="../../assets/images/governmentAffairs/top_xieshang.png" />
            <br />
            <span>大数据平台</span>
          </div> -->
                    <!-- <div :class="{ active: routeName == 'communityConsultation' }" @click="gopage('communityConsultation')"> -->
                    <!-- <a
              href="http://36.33.216.70:8086/zddj/index.html#g=1&p=%E9%A6%96%E9%A1%B5&c=1"
              target="_blank"
            > -->
                    <!-- <img src="../../assets/images/governmentAffairs/top_xueling.png" /> -->
                    <!-- </a> -->
                    <!-- <br />
            <span>智慧协商</span>
          </div>
          <div :class="{ active: routeName == 'system' }" @click="gopage('organizationIndex')">
            <img src="../../assets/images/governmentAffairs/top_setting.png" />
            <br />
            <span>系统设置</span>
          </div> -->
                    <div @click="loginOut('Home')">
                        <img
                            src="../../assets/images/governmentAffairs/top_exit.png"
                        />
                        <br />
                        <span>退&nbsp;出</span>
                    </div>
                    <!-- <div class="msgbox">
            <span>9</span>
            <img
              class="imgsfsf"
              src="../../assets/images/Gridding/griddingMsg.png"
            />
          </div>-->
                </div>
            </div>
        </el-row>
        <transition
            name="mains"
            enter-active-class="animated bounce"
            style="height: calc(100% - 64px); overflow: auto"
        >
            <router-view
                style="height: calc(100% - 64px); overflow: auto"
            ></router-view>
        </transition>
    </div>
</template>

<script>
import "@/assets/css/platform.css"
import { removeAuthor, getAuthor } from "../../utils/author"
import { Loginout } from "../../api/http"
export default {
    data() {
        return {
            routeName: "",
        }
    },
    computed: {
        menu() {
            let arr = []
            let menu = this.$store.state.menu
            for (let item in menu) {
                if (menu[item].menuType == "1") {
                    arr.push(menu[item].path)
                }
            }
            console.log(this.$store.state.menu)
            return arr
        },
    },
    methods: {
        gopage(e) {
            this.$router.push({ name: e })
        },
        // 获取当前页面路由名称
        getPageUrl() {
            window.console.log(this.$route)
            this.routeName = this.$route.matched[1].name
        },
        async loginOut(pageName) {
            let res = await Loginout({ token: getAuthor("user") })
            removeAuthor("user")
            localStorage.removeItem("token")
            localStorage.removeItem("store")
            this.$store.dispatch("logout")
            this.$router.push({ name: pageName })
        },
    },
    created() {
        this.getPageUrl()
    },
    updated() {
        this.getPageUrl()
    },
}
</script>
<style lang="less">
.rbox .el-badge__content {
    position: relative;
    top: -31px;
    left: -18px;
}
</style>
<style lang="less" scoped>
.nav {
    background-color: #207ae4;
    justify-content: center;
    .navcard {
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 15px;
        .lbox {
            img {
                width: 20vw;
            }
        }
        .rbox {
            height: 100%;
            display: flex;
            justify-content: flex-end;
            div {
                cursor: pointer;
                height: 46px;
                display: inline-block;
                text-align: center;
                padding: 9px 16px;
                margin-right: 1px;
                img {
                    width: 30px;
                    height: 30px;
                }
                span {
                    width: 100%;
                    font-size: 12px;
                    color: #fff;
                }
            }
            div:hover,
            .active {
                background-color: #0083ff;
            }
            .msgbox {
                position: relative;
                span {
                    display: inline-block;
                    width: 12px;
                    height: 12px;
                    background-color: rgb(221, 99, 99);
                    background-color: #f34c4c;
                    position: absolute;
                    top: 0px;
                    left: 12px;
                    border-radius: 50%;
                    padding: 4px;
                    color: #f2f9fd;
                    // padding: 4px;
                }
                .imgsfsf {
                    height: 60%;
                    margin-top: 20%;
                }
            }
        }
    }
}
</style>
